var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{key:_vm.key,class:{ 'v-list-item--active': _vm.isActive },on:{"click":function($event){return _vm.handleClick(_vm.item)}}},[(_vm.item.icon)?_c(_vm.item.icon,{tag:"v-list-item-icon"}):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.item.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }